import { useEffect, useRef } from 'react';
import './Section.scss';

export default function Section(props: {
    title: string,
    [key: string]: any
}) {

    const titleRef = useRef<HTMLHeadingElement>(null);
    const scrollHandler = () => {
        const top = titleRef.current?.getBoundingClientRect().top || 1;
        const isSticky = top <= 5 && top >= 0;
        
        isSticky 
            ? titleRef.current?.classList.add('-sticky') 
            : titleRef.current?.classList.remove('-sticky');
    };

    useEffect(() => {
        window.addEventListener('scroll', scrollHandler);

        return () => window.removeEventListener('scroll', scrollHandler);
    });

    return <div className='section' id={props.title.toLowerCase()}>
        <h3 ref={titleRef} className='title'>{props.title}</h3>
        <div className={`section-content ${props.title.toLowerCase()}`}>
            {props.children}
        </div>
    </div>;
};